module.exports = __webpack_public_path__ + "media/images/advisers/img_kawachino-89c28c4850114bd3906e360943938195.jpg";